import { useMemo, useState } from 'react';

type UseViewModelProps = {
  onCancel: () => void;
  onSubmit: (reason: string) => void;
};

type UseViewModelReturn = {
  reason?: string;
  reasonLength: number;
  handleReasonChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleSubmit: () => void;
  handleCancel: () => void;
};

const useViewModel = ({
  onCancel,
  onSubmit,
}: UseViewModelProps): UseViewModelReturn => {
  const [reason, setReason] = useState<string>(undefined);
  const reasonLength = useMemo(() => (reason ? reason.length : 0), [reason]);

  const handleReasonChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ): void => {
    setReason(event.target.value.trimStart());
  };

  const handleSubmit = (): void => {
    onSubmit(reason);
    setReason(undefined);
  };
  const handleCancel = (): void => {
    onCancel();
    setReason(undefined);
  };

  return {
    reason,
    reasonLength,
    handleReasonChange,
    handleSubmit,
    handleCancel,
  };
};

export default useViewModel;
